module.exports = require('./helpers/bundle-url').getBundleURL('17nMI') + "testimonial-6.40fcae92.jpeg" + "?" + Date.now();